<template>
  <proa-modal
    :modal="modal"
    :title="$t('models.project.editProjectLabels')"
    @close="$emit('close')"
  >
    <div class="edit-project-labels-modal-container">
      <div>
        <proa-button
          @click.native="addProjectLabel"
          class="unique-component-button mb-1"
        >
          {{ $t("models.project.addProjectLabel") }}
        </proa-button>
      </div>
      <p class="mt-3 text-secondary font-weight-w6">
        {{ $t("models.project.attributes.projectLabels") }}
      </p>
      <div class="project-labels-scroll-wrapper" ref="projectLabelsScrollWrapper">
        <div
          v-for="(projectLabel, i) in innerProjectLabelsAttributes"
          :key="i"
          :class="[
            'project-label-item',
            {
              'd-none': projectLabel._destroy
            }
          ]"
        >
          <div
            v-if="selectColorProjectLabelIndex == i"
            class="color-picker-modal"
            ref="colorPickerModal"
          >
            <div class="color-picker-modal-header">
              <span
                class="close-button"
                @click="selectColorProjectLabelIndex = null"
              >
                <img :src="require('@/assets/images/icons/cross_sm.png')"/>
              </span>
            </div>
            <div class="color-picker-modal-body">
              <div
                v-for="color in colors"
                :key="color"
                class="color-panel"
                :style="`background-color: ${color};`"
                @click="onSelectProjectLabelColor(color)"
              ></div>
            </div>
          </div>
          <div
            :class="[
              'unique-component-button project-label-color-button',
              {
                'not-set': projectLabel.color === null,
              },
            ]"
            :style="`background-color: ${projectLabel.color};`"
            @click="onClickSetProjectLabelColor(i)"
          >
            <span v-if="projectLabel.color === null">
              {{ $t("models.projectLabel.placeHolders.color") }}
            </span>
            <img v-else :src="require('@/assets/images/icons/change_color.png')"/>
          </div>
          <div class="unique-component-input-wrapper">
            <proa-input
              v-model="projectLabel.title"
              :invalid="projectLabel.title.length > 15"
              type="text"
              :placeHolder="$t('models.projectLabel.placeHolders.title')"
              class="unique-component-input"
              dark
            />
            <div
              v-if="projectLabel.title.length > 15"
              class="invalid-title"
            >
              {{ $t("models.projectLabel.invalidTitle") }}
            </div>
          </div>
          <proa-button
            class="unique-component-button project-label-delete-button"
            @click.native="onClickDeleteProjectLabel(i)"
          >
            {{ $t("common.deleteShort") }}
          </proa-button>
        </div>
      </div>
    </div>
    <template slot="footer">
      <proa-button
        @click.native="$emit('close')"
        class="default-button-width mr-2"
      >
        {{ $t("common.cancel") }}
      </proa-button>
      <proa-button
        @click.native="
          $emit('onUpdateProjectLabels', innerProjectLabelsAttributes)
        "
        :disabled="invalid"
        class="default-button-width"
      >
        {{ $t("common.ok") }}
      </proa-button>
    </template>
  </proa-modal>
</template>

<script>
export default {
  name: "EditProjectLabelsModal",
  props: {
    projectLabelsAttributes: Array,
    modal: Boolean,
  },
  computed: {
    colors: () => {
      return [
        '#FF0000',
        '#FF6496',
        '#9B27AE',
        '#673BB6',
        '#3F51B5',
        '#2095F2',
        '#21A8F2',
        '#25BBD4',
        '#1B9587',
        '#4DAE51',
        '#8BC24B',
        '#CCDB3A',
        '#F5DC1E',
        '#FFC83C',
        '#FF9600',
        '#FC5722',
        '#795549',
        '#AAAAAA',
        '#646464',
        '#020201'
      ]
    },
    invalid: function() {
      return this.innerProjectLabelsAttributes.filter((projectLabel) => {
        return !projectLabel.title || projectLabel.color == null || projectLabel.title.length > 15
      }).length != 0
    }
  },
  data() {
    return {
      innerProjectLabelsAttributes: [],
      selectColorProjectLabelIndex: null,
    }
  },
  methods: {
    initProjectLabelsAttributes: function () {
      this.innerProjectLabelsAttributes = JSON.parse(JSON.stringify(this.projectLabelsAttributes))
    },
    addProjectLabel: function () {
      this.innerProjectLabelsAttributes.push({
        title: "",
        color: null,
      })
      this.selectColorProjectLabelIndex = null
      this.$nextTick(() => {
        this.$refs.projectLabelsScrollWrapper.scrollTo(0, this.$refs.projectLabelsScrollWrapper.scrollHeight)
      })
    },
    onClickDeleteProjectLabel: function(index) {
      const projectLabel = this.innerProjectLabelsAttributes[index]
      if (projectLabel.id) {
        this.innerProjectLabelsAttributes = this.innerProjectLabelsAttributes.map((projectLabel, i) => {
          if (index == i) {
            return Object.assign(projectLabel, {
              _destroy: true
            })
          } else {
            return projectLabel
          }
        })
      } else {
        this.innerProjectLabelsAttributes.splice(index, 1)
      }
    },
    onClickSetProjectLabelColor: function(index) {
      this.selectColorProjectLabelIndex = index
      this.$nextTick(() => {
        // NOTE: 同じref名で生成するがv-ifで必ず1つしか描画しないので[0]でOK
        this.$refs.colorPickerModal[0].scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'nearest'
        })
      })
    },
    onSelectProjectLabelColor: function(color) {
      this.innerProjectLabelsAttributes = this.innerProjectLabelsAttributes.map((projectLabel, i) => {
        if (this.selectColorProjectLabelIndex == i) {
          return Object.assign(projectLabel, {
            color: color
          })
        } else {
          return projectLabel
        }
      })
      this.selectColorProjectLabelIndex = null
    }
  },
  watch: {
    modal: function (value) {
      if (!value) return;
      this.selectColorProjectLabelIndex = null
      this.initProjectLabelsAttributes()
    },
  },
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";

.edit-project-labels-modal-container {
  display: flex;
  flex-direction: column;
  height: 100%;

  .project-labels-scroll-wrapper {
    flex-grow: 1;
    overflow-y: auto;
  }

  .project-label-item {
    margin-bottom: 15px;
    display: flex;
    position: relative;
  }
}

.unique-component-button {
  width: 122px !important;
  height: 34px !important;
  padding: 0 !important;

  &.project-label-color-button {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border-radius: 2px;
    user-select: none;
    margin-right: 15px;

    &.not-set {
      background-color: $light-gray-color;
      color: $light-text-color;
      border: 1px solid $dark-border-color;
    }

    img {
      width: 10px;
      height: 13px;
    }
  }

  &.project-label-delete-button {
    width: 56px !important;
  }
}

.unique-component-input-wrapper {
  flex-grow: 1;
  width: auto !important;
  margin-right: 15px;

  .unique-component-input {
    height: 34px !important;

    &::placeholder {
      color: $light-text-color;
    }
  }

  .invalid-title {
    color: $error-color;
    font-size: 12px;
  }
}

.color-picker-modal {
  width: 140px;
  height: 140px;
  left: 100px;
  top: 17px;
  position: absolute;
  background-color: white;
  box-shadow: 0px 0px 4px #00000026;
  border-radius: 4px;
  padding: 15px;
  z-index: 2;

  &:after {
    content: "";
    width: 100%;
    height: 10px;
    top: 100%;
    left: 0;
    position: absolute;
  }

  .color-picker-modal-header {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    margin-bottom: 10px;

    .close-button {
      width: 10px;
      height: 10px;
      display: flex;
      justify-content: flex-end;
      cursor: pointer;

      img {
        width: 10px;
        height: 10px;
      }
    }
  }

  .color-picker-modal-body {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -5px -5px 0;

    .color-panel {
      width: 18px;
      height: 18px;
      border-radius: 2px;
      cursor: pointer;
      margin: 0 5px 5px 0;
    }
  }
}
</style>
